import { AlertMessage, Theme, useTranslation, IconStyle, useSession } from '@nextgen-web-framework/all';
import {
  CartEntryDetails,
  getErrorFromEntryOrSubCart,
  checkOutOfStockProduct,
  checkIfFreeGiftOutOfStock,
  isSopExpired,
  SubCartDetail,
  isExceptionExist,
  DeliveryType,
  ExceptionsEnum,
  AmwayUserDetailsStatusEnum,
} from '@commerce-cart-webcomponents/sdk';
import styles from './GCOErrorList.module.scss';

interface GCOErrorListProps {
  itemCart: SubCartDetail;
  isTypeCart: boolean;
  mainIndex: number;
  clickedShowCart?: (a: string) => void;
}

export function GCOErrorList({ itemCart, isTypeCart, mainIndex, clickedShowCart }: GCOErrorListProps) {
  const t = useTranslation();
  const inventoryUpdatedText = t('cart.gcoList.inventoryUpdate');
  const outOfStockText = t('cart.gcoList.outOfStock');
  const giftItemOutOfStockText = t('cart.gcoList.giftItemOutOfStock');
  const { isABO } = useSession();

  const value = itemCart.entries?.find(
    (entry: CartEntryDetails) =>
      entry?.rationingResult?.[0]?.availableQuantity !== undefined &&
      entry?.rationingResult?.[0]?.availableQuantity < entry.quantity,
  );
  const { promotionalItemOptions } = itemCart;

  const showAlertMsgOnGCO = (text: string, isinfo?: boolean, showChevron?: boolean) => (
    <AlertMessage
      content={{
        heading: text,
      }}
      theme={isinfo ? Theme.GRAY : Theme.ERROR}
      icon={isinfo ? 'tags' : 'exclamation-square'}
      iconColor={isinfo ? Theme.SUCCESS : Theme.ERROR}
      iconStyle={isinfo ? IconStyle.SOLID : IconStyle.REGULAR}
      {...(showChevron && { onChevronClick: () => clickedShowCart?.(itemCart.subCartId as string) })}
    />
  );

  return (
    <>
      {isTypeCart && (
        <div className={styles['commerce-cart-gco-line-item-gco-error']}>
          {value && (
            <AlertMessage
              content={{
                heading: t('cart.gcoList.limitExceeded'),
              }}
              icon="exclamation-square"
              theme={Theme.ERROR}
            />
          )}
          {mainIndex !== 0 && !!getErrorFromEntryOrSubCart(itemCart) && (
            <AlertMessage content={{ heading: inventoryUpdatedText }} icon="exclamation-circle" />
          )}
          {isABO() &&
            itemCart?.amwayUser?.status === AmwayUserDetailsStatusEnum.Inactive &&
            showAlertMsgOnGCO(t('cart.gcoErrorList.recipientBlocked'))}

          {Boolean(promotionalItemOptions?.length) && showAlertMsgOnGCO(t('cart.gcoList.specialOffer'), true, true)}
          {isSopExpired(false, itemCart) && showAlertMsgOnGCO(t('cart.cartlineItemHeader.subscriptionExpired'))}

          {/* shipping Error */}
          {isExceptionExist(DeliveryType.Bopis, itemCart.errors ?? []) &&
            showAlertMsgOnGCO(t('cart.cartLineItemsHeader.noPickUp'))}
          {isExceptionExist(DeliveryType.Homedelivery, itemCart.errors ?? []) &&
            showAlertMsgOnGCO(t('cart.cartLineItemsHeader.noHomedelivery'))}
          {(isExceptionExist(DeliveryType.Kerry, itemCart.errors ?? []) ||
            isExceptionExist(DeliveryType.Seveneleven, itemCart.errors ?? [])) &&
            showAlertMsgOnGCO(t('cart.cartLineItemsHeader.no3rdPartyPickup'))}

          {isExceptionExist(ExceptionsEnum.Exceptions.Restricted, itemCart.errors ?? []) &&
            showAlertMsgOnGCO(t('cart.gcoErrorList.restrictFromCheckout'))}

          {checkOutOfStockProduct(itemCart.entries as CartEntryDetails[]) && (
            <AlertMessage content={{ heading: outOfStockText }} icon="exclamation-circle" theme={Theme.ERROR} />
          )}
          {checkIfFreeGiftOutOfStock(itemCart.entries as CartEntryDetails[]) && (
            <AlertMessage
              content={{ heading: giftItemOutOfStockText }}
              icon="exclamation-circle"
              theme={Theme.WARNING}
            />
          )}
        </div>
      )}
    </>
  );
}

export type { GCOErrorListProps };
